const Line = () => {
  return <div className="h-1"></div>;
};

export default Line;
